import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import AddToProjectButton from "../components/AddToProjectButton.jsx";
import Alert from "../components/Alert.jsx";
import AppFocusLayout from "../components/AppFocusLayout.jsx";
import Button from "../components/Button.jsx";
import Icon from "../components/Icon.jsx";
import TalentAction from "../components/TalentAction.jsx";
import TalentDetails from "../components/TalentDetails.jsx";
import TalentHeader from "../components/TalentHeader.jsx";
import TalentMoreAction from "../components/TalentMoreAction.jsx";
import TalentShortView from "../components/TalentShortView.jsx";

import { sendError } from "../errors.js";
import i18n from "../i18n.js";
import { selectCanSeeTalentPool, setLoading } from "../store";
import talentsApi from "../api/talents";
import usePreviewClickHandler from "../hooks/usePreviewClickHandler";

export default function TalentDetailPage(props) {
  const params = useParams();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [talent, setTalent] = useState(null);

  useEffect(async () => {
    dispatch(setLoading());
    try {
      const talent = await talentsApi.one(params.id);
      setTalent(talent);
    } catch (err) {
      setError("Could not load talent data.");
      sendError(err);
    }
  }, []);

  function handleStateChange(newData) {
    setTalent({ ...talent, state: newData.state });
  }

  if (!talent) {
    return (
      <AppFocusLayout title={i18n.t("pages.titles.talentPool")}>
        {error && <Alert error>{error}</Alert>}
      </AppFocusLayout>
    );
  }

  const { handleClickWhenLoggedIn } = usePreviewClickHandler(
    selectCanSeeTalentPool
  );

  return (
    <AppFocusLayout
      ornamented
      closerAction={
        <Button text to={props.backUrl && props.backUrl(params)}>
          <Icon>close</Icon>
        </Button>
      }
      title={
        props.previewMode
          ? i18n.t("pages.titles.talentPool")
          : i18n.t("pages.titles.talentDetail", { name: talent.data.name })
      }
    >
      <TalentHeader userData={talent.data} previewMode={props.previewMode}>
        <AddToProjectButton
          talent={talent}
          onClick={handleClickWhenLoggedIn(() => true)}
        />
        <TalentAction
          class="ml-8 mb-8"
          talent={talent}
          onChange={handleStateChange}
          onClick={handleClickWhenLoggedIn(null)}
        />
        <TalentMoreAction talent={talent} setTalent={setTalent} />
      </TalentHeader>

      <div class="row">
        <div class="col s12 m10 push-m1">
          <TalentShortView
            previewMode={props.previewMode}
            class="mb-48"
            user={talent.data}
            talent={talent}
          />
        </div>

        <div class="col s12 m8 push-m1">
          <TalentDetails previewMode={props.previewMode} user={talent.data} />
        </div>
      </div>
    </AppFocusLayout>
  );
}
